export default {
  modules: {},
};
